var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"dot1"}),_c('span',{staticClass:"dot2"}),_c('span',{staticClass:"dot3"})])}]

export { render, staticRenderFns }